import Vue from "vue";
import Router from "vue-router";
import Search from "./views/Search.vue";
import Api from "@/services/Api.service.js";
import Dashboard from "@/views/Dashboard.vue";

import store from "./store/store.js";

Vue.use(Router);

let dashboardAccess = async function(token) {
  let result = await Api.post("dashboard/dashboardControl.php", {
    'access_token': token
  });
  console.log(result);
  if (result.data) {
    return true;
  } else {
    return false;
  }
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      url: "/search",
      name: "search",
      component: Search,
      props: route => ({
        loginKey: route.query.loginKey,
        // points: route.query.points,
        firstName: route.query.firstName,
        surname: route.query.surname,
        transactionId: route.query.transactionId,
        msisdn: route.query.msisdn,
        tier: route.query.tier,
        pickupLocation: route.query.pickupLocation,
        dropoffLocation: route.query.dropoffLocation,
        dropoffTime: route.query.dropoffTime,
        pickupTime: route.query.pickupTime,
      })
    },
    {
      path: "/results",
      url: "/results",
      name: "results",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Results.vue")
    },
    {
      path: "/details",
      name: "details",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Details.vue")
    },
    {
      path: "/confirmation",
      name: "confirmation",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Confirmation.vue")
    },
    {
      path: "/failure",
      name: "failure",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Failure.vue")
    },
    {
      path: "/loader",
      name: "loader",
      meta: {
        requiresAuth: true
      },
      component: () => import("./views/Loader.vue")
    },
    {
      path: "/dashboard",
      name: "dashboard",
      beforeEnter: async function(to, from, next) {
        if (await dashboardAccess(to.query.access_token)) {
          next(); // allow to enter route
        } else {
          next("/");
        }
      },
      component: Dashboard
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    store.state.login ? next() : window.open('https://www.investectravel.com/', "_self");
  } else {
    next();
  }
});

export default router;
